<span class="flex--row flex--nowrap flex--align-center">
  @if ((percentage$ | async) < 100) {
    <span class="text--no-wrap spacing--margin-right"
      >{{ completed$ | async }}/{{ copying$ | async }} {{ 'copyAdvice.progress' | translate }}</span
    >
    <mat-progress-bar
      style="min-width: 240px"
      [mode]="(percentage$ | async) > 0 ? 'determinate' : 'indeterminate'"
      [value]="percentage$ | async"
    ></mat-progress-bar>
  } @else {
    <span class="flex--row flex--nowrap flex--align-center">
      <mat-icon class="text-color--primary spacing--margin-half-right">check</mat-icon>
      <span class="text--no-wrap">{{ 'copyAdvice.complete' | translate }}</span>
    </span>
  }
</span>
